import React from "react";
import { observer } from "mobx-react";
import { PublisherCollectingSocietyCreateStore } from "../../store";
import { PublisherCollectingSocietyCreateForm } from "./PublisherCollectingSocietyCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PublisherCollectingSocietyCreateProps = {
  publisherCollectingSocietyCreateStore: PublisherCollectingSocietyCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PublisherCollectingSocietyCreate: React.FC<PublisherCollectingSocietyCreateProps> =
  observer(
    ({
      publisherCollectingSocietyCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={publisherCollectingSocietyCreateStore.isSaving}
          />
          <PublisherCollectingSocietyCreateForm
            publisherCollectingSocietyCreateStore={
              publisherCollectingSocietyCreateStore
            }
            collectingSocietyError={
              publisherCollectingSocietyCreateStore.errors.collectingSociety
                ?.message
            }
            onCollectingSocietyChange={(value) => {
              publisherCollectingSocietyCreateStore.setCollectingSocietyValue(
                value
              );
            }}
            collectingSocietySelectedValue={
              publisherCollectingSocietyCreateStore.entityValues
                .showCollectingSociety
            }
            onCollectingSocietySelected={(value) => {
              publisherCollectingSocietyCreateStore.setSelectedCollectingSociety(
                value
              );
            }}
            collectingSocietyOptions={publisherCollectingSocietyCreateStore.getCollectingSocietyOptions()}
            cmsAccountNumberError={
              publisherCollectingSocietyCreateStore.errors.cmsAccountNumber
                ?.message
            }
            onCmsAccountNumberChange={(value: string) => {
              publisherCollectingSocietyCreateStore.setCmsAccountNumberValue(
                value
              );
            }}
            cmsAccountNumber={
              publisherCollectingSocietyCreateStore.entityValues
                .cmsAccountNumber
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={publisherCollectingSocietyCreateStore.isProcessing}
            onSave={() =>
              publisherCollectingSocietyCreateStore.saveNewPublisherCollectingSociety()
            }
            onCancel={() =>
              publisherCollectingSocietyCreateStore.cancelNewPublisherCollectingSociety()
            }
          />
          <ErrorDialog
            open={publisherCollectingSocietyCreateStore.errorDialogOpened}
            title={publisherCollectingSocietyCreateStore.errorTitle}
            description={publisherCollectingSocietyCreateStore.errorDescription}
            onClose={() =>
              publisherCollectingSocietyCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
